export default __webpack_public_path__ + "static/media/filament.7ca96233.svg";